<template>
  <div class="whs-detail-rooms-fullscreen" v-if="room">
    <FullscreenGallery
      v-if="room.info.image_list_tmpl"
      :images="room.info.image_list_tmpl"
      :toggleFullscreen="closeRoom"
      :getImage="getFullscreenImage"
      :hasSidebar="true"
    >
      <div class="whs-detail-rooms-fullscreen-sidebar">
        <div class="whs-detail-room-name">{{ room.info.name }}</div>
        <!-- <div class="whs-detail-room-subtitle">{{ room.info.name_struct.bedding_type }}</div> -->
        <div class="whs-detail-room-description">{{ room.info.description }}</div>
        <DetailIcons
          class="whs-detail-icons-fullscreen"
          v-if="room.info && room.info.ota_room_amenity_data && room.info.ota_room_amenity_data.length > 0"
          :amenities="room.info.ota_room_amenity_data"
        />
        <div class="whs-form-submit" @click="toggleFeedbackForm(room.book_hash)">Забронировать</div>
      </div>
    </FullscreenGallery>
  </div>
</template>

<script>
import FullscreenGallery from '../components/FullscreenGallery.vue';
import DetailIcons from '../components/HotelDetailIcons.vue';

export default {
  name: 'RoomFullscreen',
  components: {
    FullscreenGallery,
    DetailIcons
  },
  props: {
    room: Object,
    closeRoom: Function,
    toggleFeedbackForm: Function
  },
  methods: {
    getFullscreenImage(num) {
      if (!this.room.info.image_list_tmpl || this.room.info.image_list_tmpl.length === 0) return false;

      return this.room.info.image_list_tmpl[num].src_secure.replace(
        '{size}',
        'orig'
      );
    }
  }
};
</script>

<style scoped>
.whs-detail-rooms-fullscreen-sidebar {
  display: flex;
  height: 100%;
  max-height: 100vh;
  overflow: auto;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 300px;
  padding: 24px;
  background: #fff;
}
.whs-detail-icons-fullscreen {
  max-height: unset;
  justify-content: flex-start;
  align-items: flex-start;
  flex-shrink: 0;
}

.whs-detail-room-name {
  font-size: 22px;
  font-weight: 600;
  color: var(--color-text);
  max-height: 38px;
  margin-bottom: 8px;
  overflow: hidden;
  flex-shrink: 0;
}
.whs-detail-room-subtitle {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-5);
  margin-bottom: 8px;
  flex-shrink: 0;
}
.whs-detail-room-description {
  margin-bottom: 18px;
  font-size: 16px;
  color: var(--color-text-5);
  flex-shrink: 0;
}
.whs-form-submit {
  margin-top: 24px;
  width: 100%;
  background: linear-gradient(var(--color-alt) -50%, var(--color-main));
  outline: none;
  padding: 14px 20px;
  border-bottom: 2px solid var(--color-alt);
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
}
.whs-form-submit:hover {
  background: linear-gradient(
    to top,
    var(--color-second) -20%,
    var(--color-second-alt) 150%
  );
  border-bottom: 2px solid var(--color-second-alt);
}
</style>